<template>
  <div class="login">
    <!-- <Header/> -->
    <Login/>
    <!-- <Footer/> -->
  </div>
</template>

<script>
  // @ is an alias to /src
  import Header from "@/components/Header";
  import Login from "@/components/Login.vue";
  import Footer from "@/components/Footer";
  
  export default {
    name: "login",
    components: {
      Login,
      Header,
      Footer
    }
  };
</script>

<style lang="scss">
.login {
  height: 100vh;
  overflow: hidden;
}
</style>

